/** Русский словарь. Ключи — английские, тексты — по тону бренда: прибор, не тренер. */
export const ru = {
  translation: {
    tabs: {
      today: 'Сегодня',
      diary: 'Дневник',
      add: 'Ввод',
      trends: 'Тренды',
      profile: 'Профиль',
    },
    today: {
      title: 'Сегодня',
      ringTitle: 'Осталось сегодня',
      kcalUnit: 'ккал',
      gramsShort: 'г',
      protein: 'Белки',
      fat: 'Жиры',
      carbs: 'Углеводы',
      activity: 'Активность',
      activityEmpty: 'Тренировок пока нет',
      steps: 'шагов',
      minShort: 'мин',
      weight: 'Вес',
      weightAdd: 'Ввести вес',
      weightCaption: 'кг · {{delta}} за 7 дней',
      habits: 'Привычки',
      burnedNote: 'сожжено · оценка',
      habitWater: 'Вода',
      habitSteps: 'Шаги',
      habitStepsValue: '6.5к / 8к',
      habitWeigh: 'Взвеситься',
      habitNoSugar: 'Без сахара',
      mockWorkoutTitle: 'Силовая',
    },
    diary: {
      title: 'Дневник',
      empty: 'Лента дня появится здесь: приемы, тренировки, вес и отметки — в одной хронологии.',
    },
    add: {
      title: 'Ввод',
      hint: 'Здесь откроется камера: фото еды — самый частый ввод.',
      chips: {
        workout: 'Тренировка',
        weight: 'Вес',
        habit: 'Привычка',
        barcode: 'Штрих-код',
        text: 'Текст',
      },
    },
    trends: {
      title: 'Тренды',
      empty: 'Вес против плана, средний дефицит, тренировки и стрики — после первой недели данных.',
    },
    profile: {
      title: 'Профиль',
      plan: 'План и норма',
      planStub: 'Норма и Б/Ж/У — расчет по профилю, правка руками',
      theme: 'Тема',
      themeDark: 'Темная',
      themeLight: 'Светлая',
      themeSystem: 'Системная',
      language: 'Язык',
      account: 'Аккаунт',
      accountStub: 'Вход по e-mail; Apple и Google — позже',
    },
  },
} as const;
